import { useParams } from "react-router-dom";
import { useApiGet } from "../utils/api";

export const useProject = () => {
  const { projectId } = useParams();
  const { data, loading, refetch } = useApiGet(`/projects/${projectId}`);
  return { project: data?.project, loading, refetch };
};
